export default __webpack_public_path__ + "activity-history-nudge-bg.png";